import React, {Component} from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import PaletteList from './PaletteList';
import Palette from './Palette';
import seedColour from './seedColour.js';
import {generatePalette} from './colourHelpers.js'



 function FindPalette(){
    const params = useParams();
    const paletteID = params.id;
    const newPalette = seedColour.find(function(palette){
      return palette.id===paletteID});
   // console.log(paletteID);
   // return( <h1>Hi</h1>)
    return <Palette palette =  {generatePalette(newPalette)}/>
    //   console.log(palette.ID);
    //   return <Palette palette= {generatePalette(seedColour(id===palette.ID))}/>;
      
    // });
  }
class App extends Component {
 
  render() {
   
  return (
    <Routes>
      <Route exact path = "/" element = {<PaletteList paletteColour = {seedColour}/>}/>
      <Route exact path="/palette/:id" element={<FindPalette/>}/>
    </Routes>
    // <div className="App">
    //  <Palette palette = {generatePalette(seedColour[1])}/>
    // </div>
  );
}
}
export default App;
